<template>
<div class="card">
  <div class="card-body help-card-body">
    <div class="text-center">
      <h4>Education</h4>
    </div>
    <hr>
    <p>You should list the highest level of education recieved, followed by next highest level and so on.</p>
  </div>
</div>
</template>

<script>
export default {
  name: 'education',
  components: {

  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style>

</style>
